import FullScreenBackgroundGradient from "@/components/backgrounds/FullScreenBackgroundGradient"
import { Vertical } from "@/components/standard/BFLayout"
import { ScrollView, View } from "react-native"
import { H2, H4, TealText } from "@/components/standard/BFText"
import BackflipLogo from "@/assets/logo/backflip-logo.svg"

import { LoanProductCard } from "@/screens/prequal/components/LoanProductCard"
import GoldTrophy from "@/assets/clipart/gold-standard-trophy.svg"
import DoubleDouble from "@/assets/clipart/double-double-bills.svg"
import Rocket from "@/assets/clipart/rocket-product.svg"
import Keys from "@/assets/clipart/refi-keys.svg"
import { BecomeMemberCTA } from "@/screens/prequal/components/BecomeMemberCTA"
import Svg, { Path, type SvgProps } from "react-native-svg"
import { DownloadAppBar } from "@/screens/prequal/components/DownloadAppBar"
import { PreQualContent } from "@/screens/prequal/components/PreQualContent"

function TopSquiggly(props: SvgProps) {
  return (
    <Svg width={166} height={43} viewBox="0 0 166 43" fill="none" {...props}>
      <Path
        d="M36.294 38.926l-.64-1.25c6.467-1.73 13.062-3.293 19.596-4.732-1.745.162-3.43.2-5.175.361-9.101.726-14.84.96-26.823.763l.044-1.372c11.797.155 17.286.003 26.575-.68 4.363-.405 8.793-.518 13.095-.798 1.06-.04 1.933-.12 2.993-.16 1.618-.328 3.364-.49 4.982-.818-21.604-.97-58.323-2.977-65.478-6.24l-2.01-1.003 2.43-.284c6.296-.525 20.28-.156 27.646.112l2.06.047c12.735.365 25.917 1.522 38.723 2.594l.624.002c7.433.56 15.607.456 23.465.143 4.617-.071 9.295-.267 14.039-.172 10.836-1.719 21.865-2.98 33.053-1.579l-.42 1.288c-8.25-1.019-16.606-.541-25.018.477 2.624.173 5.434.388 7.936.81 11.36.196 23.1.891 34.846 2.003l2.187.213-1.734.994c-3.099 1.655-7.843 1.56-12.024 1.59-.436.041-1.06.04-1.436-.044 1.508.752 2.766 1.587 3.528 2.587l1.143 1.5-2.253-.505c-6.008-1.346-25.243-2.477-35.548-3.127-1.436-.045-2.623-.173-3.622-.259-3.06-.132-6.368-.182-9.427-.315-5.368-.097-10.675-.318-16.23-.457-2.431.285-4.922.694-7.352.979-14.884 2.332-29.835 4.373-43.775 7.332zm67.243-11.888c-1.685.037-3.557.033-5.302.195-7.986.145-16.032.416-23.653-.186l-.624-.002c-12.807-1.072-25.988-2.229-38.535-2.552l-2.06-.047c-6.18-.14-16.794-.583-23.78-.352 12.766 2.86 50.418 4.662 68.46 5.25 8.224-1.061 16.701-1.788 25.245-2.223.061-.125.249-.083.249-.083zm-37.374 5.31c-1.618.329-3.176.533-4.794.861 2.054-.369 4.236-.57 6.29-.94-.624-.001-1.06.039-1.496.08zm37.517-3.896c-1.619.329-3.364.49-4.982.82 3.308.05 6.87.433 10.68.734.563.126 1.811.129 3.623.258 9.675.233 19.351.466 29.082.158a118.959 118.959 0 00-10.945-1.9l-.563-.125c-.939-.21-1.939-.297-2.877-.507-8.113-.02-16.099.125-24.018.562zm42.411 3.145c-3.429.199-6.798.273-10.106.223 5.434.389 10.371.942 13.872 1.45-.944-.626-2.137-1.17-3.766-1.673zm-4.151-2.59c1.689.38 3.191.716 4.572 1.302.188.042.436-.04.624.001 1.248.004 2.745-.076 4.18-.03 2.684.048 5.805.056 8.108-.396-6.997-.6-13.806-1.158-20.549-1.425.999.086 1.938.296 3.065.549z"
        fill="#75FAD4"
      />
    </Svg>
  )
}

function LineSquiggly(props: SvgProps) {
  return (
    <Svg width={323} height={297} viewBox="0 0 323 297" fill="none" {...props}>
      <Path
        d="M119.86 3.556c17.352 0 34.628-2.056 52.066-2.056 20.994 0 42.335 3.786 63.079 6.282 18.281 2.2 38.998 3.204 57.072 8.11 1.944.527 4.252 2.139 6.008 3.14 8.931 5.095 16.58 12 21.026 21.53 12.019 25.769-16.095 42.868-36.045 48.258-35.142 9.495-72.071 10.068-108.136 12.622-15.044 1.065-30.593 3.518-45.279 6.967-21.146 4.966-43.081 9.362-62.301 20.103-28.215 15.767-59.809 42.822-65.638 77.326-2.295 13.582 1.283 31.78 6.118 44.545 4.239 11.189 10.079 21.541 18.413 30.097 5.47 5.617 12.779 13.032 20.525 15.02"
        stroke="#286588"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </Svg>
  )
}

export const LoanProductLandingScreen = () => {
  return (
    <Vertical className={"size-full flex-1"}>
      <FullScreenBackgroundGradient preQual={true} />
      <ScrollView className={"flex-1 flex-col gap-5 relative"}>
        <View className={"p-5"}>
          <BackflipLogo />
          <H2 color={"white"} className={"px-5 pt-5 w-full text-center"}>
            Meet our {"\n"}
            <TealText>fast & friendly</TealText> loans
          </H2>
          <View className={"flex-col items-center"}>
            <TopSquiggly style={{ marginTop: -20, marginLeft: -48 }} />
          </View>
        </View>
        <View className="absolute w-full flex-col justify-center items-center top-[300px]">
          <LineSquiggly />
        </View>
        <PreQualContent>
          <View className={"self-center gap-3 max-w-[250px]"}>
            <LoanProductCard
              name={"The Standard"}
              icon={<GoldTrophy width={60} height={60} />}
              description={
                "Our core capital product, moderate leverage to boost total profit"
              }
              ltc={"85%"}
              interest={"from 9.00%"}
              origination={"from 1.25%"}
            />
            <LoanProductCard
              name={"Zero Gravity"}
              icon={<Rocket width={60} height={60} />}
              description={
                "No out of pocket lender fees, no interest payments for 6 months"
              }
              ltc={"96%"}
              interest={"from 11.75%"}
              origination={"2.00%"}
            />
            <LoanProductCard
              icon={<DoubleDouble width={60} height={60} />}
              name={"Double Double"}
              description={
                "Maximize your leverage to increase ROI on high-quality deals"
              }
              ltc={"93%"}
              interest={"from 12.75%"}
              origination={"2.00%"}
            />
            <LoanProductCard
              name={"Refi + Rehab"}
              icon={<Keys width={60} height={60} />}
              description={
                "Refinancing option for rehab projects, aimed at maximizing ROI"
              }
              ltc={"85%"}
              interest={"from 11.00%"}
              origination={"from 1.50%"}
            />
          </View>
          <H4 className={"p-5 pb-0 text-center"} color={"white"}>
            Not ready for a loan?
          </H4>
          <BecomeMemberCTA />
        </PreQualContent>
      </ScrollView>
      <DownloadAppBar />
    </Vertical>
  )
}
